/// <amd-module name="Test/TestPlansHubRefresh/TestPlanClonePanel/Redux/TestPlanClonePanelContracts" />
import { ITestHubRefreshAwareState } from "Test/TestPlansHubRefresh/TestHub/Redux/TestHubRefresh/TestHubRefreshContracts";

export interface ITestPlanClonePanelAwareState extends ITestHubRefreshAwareState {
    testPlanClonePanelState: ITestPlanClonePanelState;
}

export interface ITestPlanClonePanelState {
    areaPathNode: INode;
    iterationNode: INode;
    opId: number;
    newPlanId: number;
    cloneInProgress: boolean;
    modulesLoaded: boolean;
    mandatoryFieldUpdated: boolean;
}

export interface INode {
    id: number;
    name: string;
    guid?: string;
    structure?: INodeStructureType;
    type?: number;
    children: INode[];
    parent?: INode;
    startDate?: Date;
    finishDate?: Date;
}

/** Used in INode */
export enum INodeStructureType {
    Project = 0,
    Area = 1,
    Iteration = 2
}

export enum ClassificationNodeTypeConstants {
    ProjectType = -42,
    AreaType = -43,
    IterationType = -44
}
